// See messages/README.md for how to add strings.
// The /create studio's Sound and Video sheets (components/studio/SoundOptions,
// VideoOptions) and its upload and record views (components/modals/
// UploadSongView, MicrophoneRecordView). Effect names come from the API and
// stay as they are.
export const studioOptions = {
  en: {
    // Sound sheet
    "studioOptions.pitch.title": "Pitch",
    "studioOptions.pitch.hint":
      "In semitones. Going from a male to a female voice? Try +12.",
    // aria-label: "Lower pitch for Drake"
    "studioOptions.pitch.label": "pitch for {name}",
    "studioOptions.pitch.maleToFemale": "Male → female",
    "studioOptions.pitch.femaleToMale": "Female → male",
    "studioOptions.pitch.original": "Original",
    "studioOptions.stepper.lower": "Lower {label}",
    "studioOptions.stepper.raise": "Raise {label}",
    "studioOptions.effect.title": "Effect",
    "studioOptions.effect.hint": "One at a time. Tap again to remove it.",
    "studioOptions.effect.none": "None",
    "studioOptions.effect.onVocals": "On the vocals",
    "studioOptions.effect.onSong": "On the whole song",
    "studioOptions.autotune.title": "Autotune",
    "studioOptions.autotune.switch": "Snap the vocals to key",
    "studioOptions.autotune.hint":
      "From a light polish to the obvious robotic sound.",
    "studioOptions.autotune.light": "Light",
    "studioOptions.autotune.medium": "Medium",
    "studioOptions.autotune.strong": "Strong",
    "studioOptions.mix.title": "Mix",
    "studioOptions.mix.vocalVolume": "Vocal volume",
    "studioOptions.mix.vocalVolumeHint":
      "Louder or quieter than the music, in dB.",
    // aria-label: "Lower vocal volume"
    "studioOptions.mix.vocalVolumeLabel": "vocal volume",
    "studioOptions.mix.backing": "Split out backing vocals",
    "studioOptions.mix.backingHint":
      "Cleaner result when the song has harmonies or ad-libs.",
    "studioOptions.mix.vocalsOnly": "My audio is just vocals",
    "studioOptions.mix.vocalsOnlyHint":
      "Skips separating the vocals from the music.",
    "studioOptions.name.title": "Cover name",
    "studioOptions.name.placeholder": "Optional",

    // The Sound card's one-line summary
    "studioOptions.summary.pitch": "Pitch {values}",
    "studioOptions.summary.autotune": "Autotune",
    "studioOptions.summary.vocals": "Vocals {value}",
    "studioOptions.summary.backing": "Backing vocals split",
    "studioOptions.summary.vocalsOnly": "Vocals only input",
    "studioOptions.summary.default": "Original pitch, no effects",

    // Video sheet (Marble Run)
    "studioOptions.video.previewAria": "Preview of the Marble Run",
    "studioOptions.video.headline": "Your voices race. Whoever leads, sings.",
    "studioOptions.video.body":
      "Lead changes become voice changes, with the lyrics on screen. Ready to post on TikTok and Reels.",
    "studioOptions.video.crown": "The crown shows who's singing",
    "studioOptions.video.pickLook": "Pick a look",
    "studioOptions.video.customise": "Customise",
    "studioOptions.video.surprise": "Surprise me",
    "studioOptions.video.marbles": "Marbles and track",
    "studioOptions.video.sky": "Sky",
    "studioOptions.video.font": "Lyrics font",
    "studioOptions.video.stars": "Stars in the sky",
    "studioOptions.theme.midnight": "Midnight",
    "studioOptions.theme.neon": "Neon",
    "studioOptions.theme.ocean": "Ocean",
    "studioOptions.theme.royal": "Royal",
    "studioOptions.theme.lava": "Lava",
    "studioOptions.theme.gold": "Gold",

    // Upload view
    "studioOptions.upload.empty":
      "This file is empty. Please choose the song file again.",
    "studioOptions.upload.tooBig":
      "File size exceeds 75MB! Please upload a smaller file.",
    "studioOptions.upload.tooLong":
      "Audio duration exceeds 6 minutes! Please upload a shorter file.",
    "studioOptions.upload.invalid": "Please upload a valid audio file",
    "studioOptions.upload.unexpected": "An unexpected error occurred.",
    "studioOptions.upload.uploading": "Uploading...",
    "studioOptions.upload.coverAlt": "cover",
    "studioOptions.upload.dropIt": "Drop it",
    "studioOptions.upload.dropHere": "Drop your audio here",
    "studioOptions.upload.browse": "Browse files",
    "studioOptions.upload.formats": "MP3, WAV or M4A · up to 6 minutes",
    "studioOptions.upload.dropOrBrowse":
      "Drop an audio file or click to browse",
    "studioOptions.upload.limits": "Max 75MB, 6 mins • MP3, WAV, M4A",

    // Record view
    "studioOptions.mic.denied":
      "Allow microphone access in your browser to record.",
    "studioOptions.mic.notFound": "Couldn't find a microphone to record with.",
    "studioOptions.mic.prepareFailed": "Failed to prepare upload location.",
    "studioOptions.mic.fileFailed": "Failed to upload file.",
    "studioOptions.mic.uploadFailed": "Microphone upload failed.",
    "studioOptions.mic.previewFailed": "Could not play audio preview.",
    "studioOptions.mic.start": "Start recording",
    "studioOptions.mic.stop": "Stop recording",
    "studioOptions.mic.tapRecord": "Tap to record",
    "studioOptions.mic.tapStop": "Tap to stop",
    "studioOptions.mic.clickRecord": "Click to record",
    "studioOptions.mic.processing": "Processing...",
    "studioOptions.mic.playPreview": "Play preview",
    "studioOptions.mic.pausePreview": "Pause preview",
    "studioOptions.mic.yourRecording": "Your recording",
    "studioOptions.mic.use": "Use this recording",
    "studioOptions.mic.again": "Record again",
    "studioOptions.mic.continue": "Continue",
  },
};
